// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"04e53928","453":"494a202d","676":"ce91068a"}[chunkId] + ".chunk.js";
};